import { Component, Input } from '@angular/core';
import {
  AbstractControl,
  FormGroup,
  ReactiveFormsModule,
} from '@angular/forms';
import {
  CardModule,
  CheckboxModule,
  DropdownModule,
  RadioButtonModule,
  AlertModule,
  TooltipModule,
} from 'axis-components';
import { CommonModule, JsonPipe, SlicePipe } from '@angular/common';
import { BaseRules, TextValues } from './district-of-columbia-model';
import { UimuiBaseStateComponent } from '../uimui-base-state.component';
import { TruncateModule } from 'axis-components/truncate';

@Component({
  selector: 'app-district-of-columbia',
  standalone: true,
  imports: [
    CardModule,
    CheckboxModule,
    CommonModule,
    DropdownModule,
    ReactiveFormsModule,
    RadioButtonModule,
    AlertModule,
    SlicePipe,
    TruncateModule,
    TooltipModule,
  ],
  templateUrl: './district-of-columbia.component.html',
  styleUrl: './district-of-columbia.component.scss',
})
export class DistrictOfColumbiaComponent extends UimuiBaseStateComponent<
  BaseRules,
  TextValues
> {
  @Input() set formGroup(form: FormGroup | null) {
    if (form) {
      super.getJsonRuleFiles('district-of-columbia', form);
    }
  }
  @Input() set isReview(review: boolean) {
    if (review) {
      super.getJsonRuleFiles('district-of-columbia', null);
    }
  }

  onSelect(selectionId: string, formControlName: string): void {
    if (
      selectionId ===
        'IndividualState_Split_BodilyInjuryWithOptionalPropertyDamage' ||
      selectionId ===
        'IndividualState_Split_BodilyInjuryWithMandatoryPropertyDamage'
    ) {
      if (formControlName === 'UMBI_SplitLimits_DropDown') {
        if (this.reactiveForm.get('UMBI_SplitLimits_DropDown').valid) {
          this.reactiveForm
            .get('levelTwo_Radio')
            .setValue('LimitsUMBIUMPD_LevelTwo_Radio', { emitEvent: false });
        }
      }
    }
    if (
      selectionId ===
        'IndividualState_CombinedSingleLimit_BodilyInjuryWithOptionalPropertyDamage' ||
      selectionId ===
        'IndividualState_CombinedSingleLimit_BodilyInjuryWithMandatoryPropertyDamage'
    ) {
      if (formControlName === 'UMBI_UMPD_CombinedSingleLimit_DropDown') {
        if (
          this.reactiveForm.get('UMBI_UMPD_CombinedSingleLimit_DropDown').valid
        ) {
          this.reactiveForm
            .get('levelTwo_Radio')
            .setValue('LimitsUMBIUMPD_LevelTwo_Radio', { emitEvent: false });
        }
      }
    }
  }
}
